exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".S2DMobileView-82ae86d1{text-align:center;margin:0 30px 100px 30px}.S2DMobileView-82ae86d1 .routePreview-f764e0e6{width:150px;height:150px;margin:30px 0;border-radius:50%}.S2DMobileView-82ae86d1 .hasApp-adab388a{display:block;margin:45px 0 0 0}\n", ""]);

// Exports
exports.locals = {
	"S2DMobileView": "S2DMobileView-82ae86d1",
	"routePreview": "routePreview-f764e0e6",
	"hasApp": "hasApp-adab388a"
};